var _polygon, _polygon2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgParser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    enableBackground: "new 0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#90CAF9",
    points: "40,45 8,45 8,3 30,3 40,13"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#E1F5FE",
    points: "38.5,14 29,14 29,4.5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#1976D2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 21,
    width: 17,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 25,
    width: 13,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 29,
    width: 17,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 33,
    width: 13,
    height: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParser);
export default __webpack_public_path__ + "static/media/parser.1be07aa0f81e2d8b83f492a2865465b2.svg";
export { ForwardRef as ReactComponent };